import * as yup from 'yup';

const numberFromString = (label: string, min = 0) =>
  yup
    .string()
    .required(`${label} is required`)
    .transform((value) => (value === '' || value == null ? undefined : value))
    .test('is-number', 'Must be a number', (value) => value !== undefined && !Number.isNaN(Number(value)))
    .test('min', `Must be ≥ ${min}`, (value) => Number(value) >= min);

const optionalNumberFromString = (label: string, min = 0) =>
  yup
    .string()
    .transform((value) => (value === '' || value == null ? undefined : value))
    .test('is-number', 'Must be a number', (value) => value === undefined || !Number.isNaN(Number(value)))
    .test('min', `Must be ≥ ${min}`, (value) => value === undefined || Number(value) >= min);

export const gameDialogSchema = yup.object({
  country_code: yup.string().notRequired(),
  game_id: numberFromString('Game ID'),
  state_code: yup.string().required('State is required').min(2),
  plu: optionalNumberFromString('PLU'),
  name: yup.string().notRequired(),
  tickets_per_pack: numberFromString('Tickets per pack', 1),
  cost_per_ticket: numberFromString('Price per ticket'),
  price_per_pack: yup.string().notRequired(),
  start_date: yup.string().notRequired(),
  end_date: yup.string(),
  image_url: yup.string().url('Please enter a valid URL').nullable().notRequired().transform((value) => (value === '' ? null : value)),
  pending_plu_verification: yup.boolean().notRequired(),
});
